<template>
	<div class="login">
		<div class="login-header">
			<img src="../../assets/imgs/blmesBg.png">
		</div>
		<div class="login-box box-sizing">
			 <div class="login-wrap">
					<div class="left">
						<p class="title">门户网站后台管理平台</p>
						<!-- <p class="subtitle">
							弈能冷站体检系统,是金马节能科技(深圳)有限公司推出的公共建筑智慧节能领域应用产品 —— 专业冷站节能诊断工具
						</p>
						<p class="explain">通过对现场冷站数据的收集及过滤，基于模型分析自动诊断冷站 自身存在的用能异常和运行不合理等问题，自动生成节能诊断报告</p> -->
						<p class="img">
							<img src="../../assets/imgs/loginImg.png">
						</p>
					</div>
					<div class="right">
						<p class="title">账号登录</p>
						<el-form ref="ruleForm2" :model="ruleForm2"  :rules="rules" @submit.native.prevent>
							<el-form-item  prop="userName">
								<el-input v-model="ruleForm2.username" placeholder="账号"  @keyup.enter.native="onSubmit('ruleForm2')"></el-input>
							</el-form-item>
							<el-form-item  prop="password">
								<el-input v-model="ruleForm2.password" placeholder="密码" type="password"  @keyup.enter.native="onSubmit('ruleForm2')"></el-input>
							</el-form-item>
							<el-form-item class='submits' style='border: 0;'>
								<el-button  @click="onSubmit('ruleForm2')" :plain="true">登录</el-button>
							</el-form-item>
						</el-form>
						<p class="forget">
							<span @click='register()'>立即注册</span>
							<span>忘记密码</span>
						</p>
						<div class="otherlink" style="margin-top:52px;">
							<img src="../../assets/imgs/otherLink.png">
						</div>
					</div>
			 </div>
			

		</div>
		<div class="workName">
			<p>
				<span>帮助</span>
				<span>隐私</span>
				<span>条款</span>
			</p>
			<p>技术支持@金马节能科技（深圳）有限公司</p>
		</div>
	</div>
</template>

<script>
	export default{
		name:'login',
		data(){
			return{
				ruleForm2: {
					username:'',
					password:'',
       			 },
				rules:{
					username: [
						{ required: true, message: '请输入用户名', trigger: 'blur' },
						
					],
					password:{required: true, message: '请输入密码', trigger: 'blur'}
				},
				newUrl:'',
				imgUrl:''
				 
			}
		},
		mounted(){
		},
		methods:{
			
			onSubmit(formName) {
				var vm=this;
				// console.log(vm.ruleForm2)
				this.$refs[formName].validate((valid) => {
				if (valid) {
								this.$http.post('/api/console/login',vm.ruleForm2)
								.then(function(response){
									// console.log(response.code)
									if(response.code==0){
										localStorage.setItem('loginUserBaseInfo','admin')
										vm.$router.push({path:'/userList'})
										// vm.getComPro()
									}else{
										vm.$message.error({
											message: response.msg,
											center: false
										});
									}
								})
								.catch(function(err){
									console.log(err);
								});
				} else {
					
					return false;
				}
				});
			},
			getRootPath:function() {
				let curWwwPath = window.document.location.href;
				let pathName = window.document.location.pathname;
				let pos = curWwwPath.indexOf(pathName);
				let localhostPaht = curWwwPath.substring(0, pos).replace("http://","").replace("https://","");
				let projectName = pathName.substring(0, pathName.substr(1).indexOf('/') + 1);
				return (localhostPaht + projectName);
			},
			register:function(){
				this.$router.push({path:"/register"})
			}
		
		},
	}
</script>

<style lang="less">
	.login{
		display: flex;
		flex-direction: column;
	
		background:rgba(245,246,247,1);
		.login-header{
			height:48px;
			background:rgba(38,38,38,1);
			box-sizing:border-box;
			padding-left:30px;
			min-width:1200px;
			img{
				position: relative;
              	top:16px;
			}
		}
		.login-box{
			flex: 1;
			width: 1200px;
			margin: 0 auto;
			margin-top:4%;
		
			.login-wrap{
				height: 639px;
				box-shadow:0px 5px 8px 0px rgba(0,2,31,0.08);
				background:rgba(255,255,255,1);
				display: flex;
				box-sizing:border-box;
				padding:58px 0 24px;
				.left{
					width: 50%;
					border-right:1px solid rgba(178,178,178,1);
					box-sizing: border-box;
					padding: 21px 64px 0 71px;
					.title{
						text-align: center;
						font-size:28px;
						font-family:SourceHanSansCN-Regular;
						font-weight:400;
						color:rgba(6,6,6,1);
					}
					.subtitle{
						font-size:14px;
						font-family:SourceHanSansCN-Light;
						font-weight:300;
						color:rgba(6,6,6,1);
						line-height:24px;
						margin-top: 34px;
					}
					.explain{
						font-size:14px;
						font-family:SourceHanSansCN-Light;
						font-weight:300;
						color:rgba(6,6,6,1);
						line-height:24px;
						margin-top: 20px;
					}
					.img{
						height: 286px;
						width: 100%;
						/* border: 1px solid #ccc; */
						margin-top: 40px;
					}
				}
				.right{
					flex: 1;
					box-sizing: border-box;
					padding: 41px 128px 0 128px;
					.title{
						font-size:32px;
						font-family:SourceHanSansCN-Light;
						font-weight:300;
						color:rgba(0,0,0,1);
						text-align:center;
						margin-bottom:50px;
					}
					.submits{
						width: 100%;
						margin-top: 60px;
						.el-button{
							width: 100%;
							background:rgba(0,151,238,1);
							color:rgba(255,255,255,1);
						}
					}
				}
				.forget{
					text-align: right;
					span:first-child{
						font-size:14px;
						font-family:SourceHanSansCN-Light;
						font-weight:300;
						color:rgba(0,151,238,1);
						margin-right:10px;
						cursor: pointer;
					}
					span:last-child{
						width:55px;
						height:15px;
						font-size:14px;
						font-family:SourceHanSansCN-Light;
						font-weight:300;
						color:rgba(153,153,153,1);
					}
				}
			
			}
		}
		.workName{
			height: 88px;
			margin-top: 4%;
			p{
				height: 44px;
				line-height:44px;
				text-align:center;
				font-size:12px;
				font-family:SourceHanSansCN-Light;
				font-weight:300;
				color:rgba(153,153,153,1);
			}
			p:first-child{
				border-bottom: 1px solid rgba(178,178,178,1);
				span{
					margin-right:42px;
					font-size:14px;
					font-family:SourceHanSansCN-Light;
					font-weight:300;
					color:rgba(143,143,143,1);
				}
				span:last-child{
					margin-right: 10px;
				}
			}
		}
	}
  
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue